export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-thumbnail-960-cde712f37b31ee6fae08caccaded91f4.png";